import { useCallback, useEffect, useState } from 'react'

export const useMicrophonePermission = () => {
  const [state, setState] = useState({
    permissionResponseReceived: false,
    permissionStatus: null
  })

  const onPermissionStateChange = useCallback(microphonePermission => {
    if (!microphonePermission) {
      return
    }

    setState({
      permissionResponseReceived: true,
      permissionStatus: microphonePermission.state
    })
  }, [])

  async function checkMicrophonePermission() {
    try {
      const microphonePermission = await getMicrophonePermissionStatus()
      onPermissionStateChange(microphonePermission)
      microphonePermission.addEventListener('change', onPermissionStateChange)
      return () => {
        microphonePermission.removeEventListener(
          'change',
          onPermissionStateChange
        )
      }
    } catch {}
  }

  useEffect(() => {
    let permissionCleanup

    checkMicrophonePermission().then(cleanup => {
      permissionCleanup = cleanup
    })

    return () => {
      if (permissionCleanup) {
        permissionCleanup()
      }
    }
  }, [state.permissionStatus])

  return state
}

/**
 * @returns {PermissionStatus}
 */
export async function getMicrophonePermissionStatus() {
  if (!navigator.permissions) {
    throw new Error('navigator.permissions not supported')
  }

  try {
    const permission = await navigator.permissions.query({
      name: 'microphone'
    })
    if (!permission) {
      throw new Error('permissions are not defined')
    }
    return permission
  } catch {
    throw new Error(
      'navigator.permissions.query({ name: `microphone`}) not supported'
    )
  }
}
